import React, { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';

export default function BotUsersPage() {
  const queryClient = useQueryClient();
  const [username, setUsername] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [error, setError] = useState('');

  const { data: users = [], isLoading } = useQuery({
    queryKey: ['bot-users'],
    queryFn: () => api.get('/bot-users').then(r => r.data),
  });

  const addMutation = useMutation({
    mutationFn: (payload) => api.post('/bot-users', payload),
    onSuccess: () => {
      queryClient.invalidateQueries(['bot-users']);
      setUsername('');
      setDisplayName('');
      setError('');
    },
    onError: (e) => setError(e.response?.data?.detail || 'Ошибка'),
  });

  const deleteMutation = useMutation({
    mutationFn: (id) => api.delete(`/bot-users/${id}`),
    onSuccess: () => queryClient.invalidateQueries(['bot-users']),
  });

  const handleAdd = (e) => {
    e.preventDefault();
    if (!username.trim()) return;
    setError('');
    addMutation.mutate({
      telegram_username: username.trim(),
      display_name: displayName.trim() || null,
    });
  };

  return (
    <div style={{ padding: '24px', maxWidth: '600px', margin: '0 auto' }}>
      <h1 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '8px' }}>Пользователи бота</h1>
      <p style={{ fontSize: '13px', color: '#6b7280', marginBottom: '24px' }}>
        Telegram-логины, которым доступен запрос остатков на фабрике через бота.
      </p>

      <form onSubmit={handleAdd} style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '24px' }}>
        <div style={{ display: 'flex', gap: '8px' }}>
          <input
            className="input"
            placeholder="@username или username"
            value={username}
            onChange={e => setUsername(e.target.value)}
            style={{ flex: 1 }}
          />
          <input
            className="input"
            placeholder="Имя (необязательно)"
            value={displayName}
            onChange={e => setDisplayName(e.target.value)}
            style={{ flex: 1 }}
          />
        </div>
        <button className="btn btn-primary" type="submit" disabled={addMutation.isLoading} style={{ alignSelf: 'flex-start' }}>
          Добавить
        </button>
      </form>

      {error && (
        <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '6px', padding: '10px 14px', marginBottom: '16px', color: '#dc2626', fontSize: '13px' }}>
          {error}
        </div>
      )}

      {isLoading ? (
        <div style={{ color: '#6b7280', fontSize: '14px' }}>Загрузка...</div>
      ) : users.length === 0 ? (
        <div style={{ color: '#9ca3af', fontSize: '14px' }}>Нет пользователей</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {users.map(u => (
            <div key={u.id} style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: '8px',
              padding: '10px 14px',
            }}>
              <div>
                {u.display_name && (
                  <span style={{ fontWeight: '600', fontSize: '14px', marginRight: '8px' }}>{u.display_name}</span>
                )}
                <span style={{ fontWeight: u.display_name ? '400' : '500', fontSize: '14px', color: u.display_name ? '#6b7280' : undefined }}>
                  @{u.telegram_username}
                </span>
                {u.created_at && (
                  <span style={{ fontSize: '12px', color: '#9ca3af', marginLeft: '12px' }}>
                    {new Date(u.created_at).toLocaleDateString('ru-RU')}
                  </span>
                )}
              </div>
              <button
                onClick={() => deleteMutation.mutate(u.id)}
                style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ef4444', fontSize: '18px', padding: '2px 6px' }}
                title="Удалить"
              >
                ×
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
